import { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { ChevronDown, Pencil, Trash2, Upload, Download, Eye } from 'lucide-react';
import { DocHistory } from './DocHistory';
import { API, FileBadge, dt, fileSize, openFile } from './docLibShared';

export const AdminDocCard = ({ doc, catName, locNames, onEdit, onVersion, onDelete, onToggle }) => {
  const [open, setOpen] = useState(false);
  const v = doc.versions[doc.versions.length - 1];
  const url = `${API}/doc-library/${doc.id}/versions/${v.id}/file`;
  return (
    <Card className={`border-slate-200 transition-shadow hover:shadow-sm ${doc.is_active ? '' : 'opacity-60'}`} data-testid={`doc-card-${doc.id}`}>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start gap-3">
          <FileBadge type={v.content_type} />
          <div className="min-w-0 flex-1">
            <p className="font-semibold text-slate-900 truncate" data-testid={`doc-title-${doc.id}`}>{doc.title}</p>
            <div className="mt-1 flex flex-wrap items-center gap-1.5 text-xs">
              <Badge variant="outline">{catName}</Badge>
              <Badge className="bg-slate-900 hover:bg-slate-900" data-testid={`doc-version-${doc.id}`}>v{v.version}</Badge>
              <Badge variant="secondary" className="font-normal">Lokasyon: {locNames}</Badge>
              <span className="text-slate-500">{fileSize(v.size)} · {dt(doc.updated_at)}</span>
              <span className="flex items-center gap-1 text-sky-700" data-testid={`doc-dl-count-${doc.id}`}><Download className="h-3 w-3" />{doc.download_count || 0} indirme</span>
            </div>
          </div>
          <Switch checked={doc.is_active} onCheckedChange={(x) => onToggle(doc, x)} title="Yayında" data-testid={`doc-toggle-${doc.id}`} />
          <Button size="icon" variant="ghost" title="Görüntüle" onClick={() => openFile(url, v.name, false)} data-testid={`doc-open-${doc.id}`}><Eye className="h-4 w-4" /></Button>
          <Button size="icon" variant="ghost" className="text-emerald-600" title="Yeni sürüm yükle" onClick={() => onVersion(doc)} data-testid={`doc-new-version-${doc.id}`}><Upload className="h-4 w-4" /></Button>
          <Button size="icon" variant="ghost" className="text-blue-600" title="Düzenle" onClick={() => onEdit(doc)} data-testid={`doc-edit-${doc.id}`}><Pencil className="h-4 w-4" /></Button>
          <Button size="icon" variant="ghost" className="text-rose-600" title="Sil" onClick={() => onDelete(doc)} data-testid={`doc-delete-${doc.id}`}><Trash2 className="h-4 w-4" /></Button>
        </div>
        <button type="button" onClick={() => setOpen(!open)} className="flex w-full items-center gap-2 rounded-lg border px-3 py-2 text-sm hover:bg-slate-50 transition-colors" data-testid={`doc-history-toggle-${doc.id}`}>
          <span className="font-medium text-slate-800">Sürüm geçmişi ve indirme takibi</span>
          <ChevronDown className={`ml-auto h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        {open && <DocHistory doc={doc} />}
      </CardContent>
    </Card>
  );
};
